<div class="v3d-view-wrapper" #editor>
  <div class="sidebar-actions cf-flex-row cf-justify-content-space-between cf-gap-10">
    <div class="cf-flex-row">
      <div *ngIf="productSidebarRightOpened$ | async" class="cf-hide-xs cf-hide-sm cf-hide-md">
        <button
          mat-icon-button
          (click)="onChangeProductSidebarRightOpened(false)"
          [matTooltip]="'UI.Common.Action.CloseSidebar' | translate"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="arrow_forward"></mat-icon>
        </button>
      </div>
      <div *ngIf="(productSidebarRightOpened$ | async) === false" class="cf-hide-xs cf-hide-sm cf-hide-md">
        <button
          mat-icon-button
          (click)="onChangeProductSidebarRightOpened(true)"
          [matTooltip]="'UI.Common.Action.OpenSidebar' | translate"
          matTooltipPosition="above"
        >
          <mat-icon svgIcon="arrow_back"></mat-icon>
        </button>
      </div>
      <div *ngIf="enableDragAndDrop && productSidebarRightOpened$ | async">
        <button
          (click)="dragAndDropMode ? closeDragAndDrop() : openDragAnDrop()"
          mat-icon-button
          [matTooltip]="dragAndDropMode ? ('UI.Common.DragAndDrop.Close' | translate) : ('UI.Common.DragAndDrop.Open' | translate)"
        >
          <mat-icon svgIcon="drag_pan" [ngClass]="{ 'active-icon': dragAndDropMode }"></mat-icon>
        </button>
        <button
          *ngIf="dragAndDropMode"
          [disabled]="visualEditorState.newState.length === 0"
          mat-icon-button
          [matTooltip]="'UI.Common.DragAndDrop.Undo' | translate"
          (click)="undoDragAndDrop(true)"
        >
          <mat-icon svgIcon="undo"></mat-icon>
        </button>
      </div>
    </div>
    <span class="cf-auto"></span>
    <div *ngIf="(productSidebarRightOpened$ | async) || lessThanLargeScreen">
      <button
        mat-icon-button
        (click)="setViewPort('TopLeft')"
        [disabled]="dragAndDropMode"
        [matTooltip]="'UI.Common.ViewPoint.TopLeft' | translate"
      >
        <mat-icon svgIcon="view_topleft"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="setViewPort('TopRight')"
        [disabled]="dragAndDropMode"
        [matTooltip]="'UI.Common.ViewPoint.TopRight' | translate"
      >
        <mat-icon svgIcon="view_topright"></mat-icon>
      </button>
      <button mat-icon-button (click)="setViewPort('Top')" [matTooltip]="'UI.Common.ViewPoint.Top' | translate">
        <mat-icon svgIcon="view_top"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="setViewPort('Bottom')"
        [disabled]="dragAndDropMode"
        [matTooltip]="'UI.Common.ViewPoint.Bottom' | translate"
      >
        <mat-icon svgIcon="view_bottom"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="setViewPort('Front')"
        [disabled]="dragAndDropMode"
        [matTooltip]="'UI.Common.ViewPoint.Front' | translate"
      >
        <mat-icon svgIcon="view_front"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="setViewPort('Back')"
        [disabled]="dragAndDropMode"
        [matTooltip]="'UI.Common.ViewPoint.Back' | translate"
      >
        <mat-icon svgIcon="view_back"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="setViewPort('Left')"
        [disabled]="dragAndDropMode"
        [matTooltip]="'UI.Common.ViewPoint.Left' | translate"
      >
        <mat-icon svgIcon="view_left"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="setViewPort('Right')"
        [disabled]="dragAndDropMode"
        [matTooltip]="'UI.Common.ViewPoint.Right' | translate"
      >
        <mat-icon svgIcon="view_right"></mat-icon>
      </button>
    </div>
  </div>
  <div class="v3d-container" *ngIf="productSidebarRightOpened$ | async" [ngClass]="{ dragAndDrop: dragAndDropMode }">
    <div *ngIf="loading3dModel$ | async" class="spinner-3d">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="dragAndDropMode && selectedEntityPosition" class="coord">
      <div>{{ getCoordinates(selectedEntityPosition) }}</div>
    </div>
    <v3d-orthographic-view
      *ngIf="currentObject3d$ | async as obj3d"
      [class.hidden]="loading3dModel$ | async"
      [v3dObject]="obj3d"
      [viewerOptions]="viewerOptions"
      [sceneManager]="sceneManager"
      (v3dObjectClick)="on3DObjectClick($event)"
      (v3dObjectLoadStatus)="loadStatusChange($event)"
      (pointermove)="onPointerMove($event)"
    ></v3d-orthographic-view>
  </div>
</div>
